/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function(a){

  	a('body').on('click', '.cart-recap__checkout', function() {
      a(this).addClass('btn--loading');
    });
                                   
    a('body').on('click', '.cart__checkout--ajax', function(evt) {
      if (a('.haz-warning').length) {
        if (a('#HazWarning').is(':checked')) {
        } else {
          alert('You must agree with the ORM-D/Hazmat shipping restrictions to check out');
          a(this).removeClass('btn--loading');
          return false;
        }
      }
    });
  
    a('body').on('click', '.cart-recap__checkout', function(evt) {
      if (a('.haz-warning').length) {
        if (a('#HazWarning').is(':checked')) {
        } else {

          alert('You must agree with the ORM-D/Hazmat shipping restrictions to check out');
          setTimeout(function(){
            a('.cart-recap__checkout').removeClass('btn--loading');
          }, 500);
          return false;
        }
      }
    }); 
                                   
    a('.haz-warning').hover(
      function(){
        a(this).siblings('.warn-holder').fadeIn('1000');                       
      },
      function(){
        a(this).siblings('.warn-holder').fadeOut('500'); 
      } 
    );

});
// End document ready